import _ from 'lodash'

export function number(value) {
    return _.floor(value, 2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
}

export function date(value) {
    return (value.length <= 10) ? value : value.substr(0, value.length - 3);
}


export function AuthorizationFormat(value) {
    let words = value.split(" ");
    let initials= ''
    for (let i = 0; i < words.length; i++) 
        initials += words[i].charAt(0);
    return initials;
}

export function timeFormat(value = null) {
    if (typeof value === 'undefined' || value == null) {
        return '';
    } else {
        var x = '';
        x = (value + '').length == 1 ? (value = '00' + value) : value + '';
        x = (value + '').length == 2 ? (value = '00' + value) : value + '';
        x = (value + '').length == 3 ? (value = '0' + value) : value + '';
        x = [x.slice(0, 2), ':', x.slice(2)].join('');
        return x.replace('::', ':');
    }

}

export function statusString(value) {
    let name = '';
    switch (value) {
        case 'warning':
            name = 'Periodo de renovación'
            break;
        case 'error':
            name = 'Vencidó'
            break;
        case 'success':
            name = 'Vigente'
            break;
    }
    return name;

}

export function dataFormatWord(date) {
    var mount = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let tempoDate = new Date(date);
    tempoDate.setMinutes(tempoDate.getMinutes() + tempoDate.getTimezoneOffset())
    return tempoDate.getDate() + ' de ' + mount[tempoDate.getMonth()] + ' de ' + tempoDate.getFullYear();
}

export function dateFormat(value) {
    const date = new Date(value);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Sumamos 1 porque los meses se indexan desde 0
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
}

export function kbbtsToMbs(kbts) {
    var rs = ((parseInt(kbts)) / 1024) / 1024;
    return rs.toFixed(2);
}

export function dayForPay(date){
   
   var dateToday = new Date();
   var partDate = dateFormat(date).split('-');
   var day = parseInt(partDate[0]);
   var month = parseInt(partDate[1]) - 1; 
   var year = parseInt(partDate[2]);
   var dateNew = new Date(year, month, day);
   var available  = dateToday - dateNew;
   var result = Math.floor(available / (1000 * 60 * 60 * 24));

   return result * -1; 
}

export function sapCodeToText(code) {
    const table = {
        18: () => {
            return 'Factura de proveedor'
        },
        20: () => {
            return 'Entrada'
        },
        22: () => {
            return 'Orden de compra'
        },
    }
    return table[code] ? table[code]() : 'No existe información';
}

/*
Sirve para formatear fechas con hora con timestamp como crated_at
Entrada: "2026-09-25T22:10:06.000000Z"
Salida: "25/09/2026"
*/
export function shortDateFormat(dateString) {
    if (!dateString) return '';

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export function shortIVA(codigo){
    const match = codigo.match(/IVA(\d+)C/i);
    if (match) {
        return `${parseInt(match[1])}%`;
    }
    return 'IVA desconocido';
}

export function shortDateWithShortInput(dateString){
    if (!dateString) return '';
    let dateArr = dateString.split("-");
    const day = dateArr[2];
    const month = dateArr[1];
    const year = dateArr[0];
    return `${day}/${month}/${year}`;
}

export function moneyFormat(value){
    const number = Number(value);

    // Se multiplica por 100
    const truncated = Math.trunc(number * 100) / 100;

    // Formateamos con separadores de miles y 2 decimales exactos
    return '$ ' + truncated.toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}
/*
Sirve para formatear fechas con hora
Entrada: "2026-09-21 14:10:08"
Salida: "21/09/2026 14:10:08"
*/
export function formLongDateTime(date) {
    const [fecha, hora] = date.split(' ');
    const [year, month, day] = fecha.split('-');

    return `${day}/${month}/${year} ${hora}`;
}